<template>
  <simplebar class="orders-filters" data-simplebar-auto-hide="false">
    <div class="orders-filters__wrapper">
      <div class="orders-filters__link-container">
        <div
          v-for="item in list"
          :key="item.id"
          :class="{ 'is-active': item.id === value }"
          class="orders-filters__link"
          v-text="item.label"
          @click="handlerClick(item.id)"
        />
      </div>
    </div>
  </simplebar>
</template>

<script>
import simplebar from 'simplebar-vue';

export default {
  name: 'OrdersFilters',
  components: {
    simplebar,
  },
  props: {
    value: String,
    list: {
      type: Array,
      required: true,
    },
  },
  methods: {
    /**
     * Обработчик клика на элемент фильтра
     * @param id
     */
    handlerClick(id) {
      if (id === this.value) {
        this.$emit('input', this.list[0].id);
      } else {
        this.$emit('input', id);
      }
    },
  },
};
</script>

<style lang="scss">
.orders-filters {
  padding-bottom: 10px;
  margin: 0 0 20px;

  &__wrapper {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  &__title {
    margin: 0 20px 0 0;
    font-size: rem(13);
    font-weight: 300;
    line-height: 24px;
    color: #030303;
    white-space: nowrap;
    opacity: 0.5;
  }

  &__link {
    font-size: rem(13);
    font-weight: 300;
    color: $color-black;
    text-decoration: none;
    white-space: nowrap;
    cursor: pointer;
    opacity: 0.7;
    transition: all 0.2s;

    & + & {
      margin-left: 20px;
    }

    &.is-active {
      font-weight: bold;
      opacity: 1;

      &:hover {
        text-decoration: none;
      }
    }

    &:hover {
      text-decoration: underline;
      opacity: 1;
    }

    &-container {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
  }
}
</style>
